import { createZustandStore } from '../../../zustand';

import { IGradeReviewListFilterState } from './types';
import { onClearGradeReviewFilterStoreCallback } from './callbacks';

/**
 * This creates a global grade review filter state tracker and update the filter
 * values.
 */
export const useGradeReviewListFilterStore =
  createZustandStore<IGradeReviewListFilterState>()((set) => ({
    clearGradeReviewListFilterStore: onClearGradeReviewFilterStoreCallback(set),
    dateRange: null,
    grrListColumns: {},
    grrListPageSize: 20,
    onUpdateGradeReviewDateRange: (dateRange) => set(() => ({ dateRange })),
    onUpdateSelectedStatuses: (statuses) =>
      set(() => ({ selectedStatuses: statuses })),
    selectedGradeFilters: [],
    selectedStatuses: [],
    updateGrrListColumns: (visibility) =>
      set(() => ({ grrListColumns: visibility })),
    updateGrrListPageSize: (pageSize) =>
      set(() => ({ grrListPageSize: pageSize })),
    updateSelectedGradeFilters: (filters) =>
      set(() => ({ selectedGradeFilters: filters })),
  }));
